import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/3.png'


const _withScopeId = n => (_pushScopeId("data-v-0578ab1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "step-number" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-description" }, "UPLOAD YOUR LOGO", -1))
const _hoisted_5 = { class: "upload-section" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "upload-button",
  class: "input-link"
}, "Browse files", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " to upload", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "button-container"
}
const _hoisted_11 = {
  key: 2,
  class: "loaded-image"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Max size: 10MB"),
  /*#__PURE__*/_createElementVNode("div", null, "Accepted types: JPG,JPEG,PNG,SVG")
], -1))
const _hoisted_14 = {
  key: 0,
  class: "slider"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-size-disclaimer" }, " *The logo size on the Design Your Own Tool is a guide only. The maximum height of an embroidered logo is 5.5cm ", -1))
const _hoisted_16 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Sublimated badge", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " + $0.50 extra", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DisclaimerText = _resolveComponent("DisclaimerText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "STEP " + _toDisplayString(_ctx.activeSidebarOption ? _ctx.activeSidebarOption.stepNumber : ""), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        id: "upload-button",
        type: "file",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLogoUpload && _ctx.onLogoUpload(...args))),
        accept: "image/*"
      }, null, 544), [
        [_vShow, false]
      ]),
      (!_ctx.loadedImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.loadedImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              size: "small",
              class: "button",
              severity: "danger",
              onClick: _ctx.removeLogo,
              text: "",
              raised: "",
              rounded: ""
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loadedImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("img", {
              src: _ctx.loadedImage,
              alt: ""
            }, null, 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_13,
    (
        _ctx.loadedImage &&
        (_ctx.productType === 'truckercap' ||
          _ctx.productType === 'cut_bucket_hat' ||
          _ctx.productType === 'sub_bucket_hat' ||
          _ctx.productType === 'terry_bucket_hat')
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_Slider, {
            modelValue: _ctx.logoSize,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.logoSize) = $event)),
            onChange: _ctx.logoSizeChange,
            max: 30,
            min: 5
          }, null, 8, ["modelValue", "onChange"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loadedImage && _ctx.isBadgeAddonAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_Checkbox, {
            modelValue: _ctx.sublimatedBadgeAddonState,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sublimatedBadgeAddonState) = $event)),
            binary: true,
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onBadgeTypeChange()))
          }, null, 8, ["modelValue"]),
          _hoisted_17,
          _hoisted_18,
          _hoisted_19
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DisclaimerText)
  ]))
}